export const onyx = '#212B36';
export const blackOpacity = '#00000040';
export const onyxLight = '#454F5B';
export const onyxLighter = '#637381';
export const onyxLightest = '#5E6A75';
export const cloud = '#C4CDD5';
export const cloudLight = '#DFE3E8';
export const cloudLighter = '#F4F6F8';
export const cloudLightest = '#F9FAFB';
export const white = '#FFFFFF';
export const black = '#000000';
export const grey80 = '#3D3D3D80';
export const alabaster = '#F7F7F7';
export const silverChalice = '#757575';
export const darkGray = '#757575';
export const alto = '#DDDDDD';
export const dustygray = '#959595';
export const nobel = '#999999';
export const denim = '#1D5BBF';
export const grayscale = '#878787';
export const ravenBlack = '#3D3D3D';
export const doctor = '#F8F8F8';
export const gravelfint = '#BBBBBB';
export const olympicBlue = '#5A91F7';
export const greyopacity = '#1E1E1EBF';
export const lightGray = '#FAFAFA';
export const taupe = '#79766E';
export const greyf7 = '#f7f7f7';
export const jungleGreen = '#2AAA8A';
export const dodgerBlue = '#007AFF';
export const neutral200 = '#F0F0F0';
export const neutral300 = '#E5E5E5';
export const neutral350 = '#E5E5EA';
export const neutral400 = '#E0E0E0';
export const neutral500 = '#D6D6D6';
export const neutral600 = '#CCCCCC';
export const wildSand = '#F4F4F5';
export const stormGray = '#6F6F73';
export const silverSand = '#C8C9CC';
export const hitGray = '#A7A9AE';
export const chambray = '#44518F';
export const errorRed = '#D12B2B';
export const chatHistoryCardBorder = '#DCE8F8';
export const chatHistoryCardBackground = '#F7FAFF';
export const chatHistoryActiveItemBackground = '#F4F9FF';
export const chatTableHeaderBackground = '#F4F8FF';
export const chatTableHeaderText = '#163A75';
export const chatTableCellText = '#10294D';
export const chatTableBorderStrong = 'rgba(28, 76, 146, 0.12)';
export const chatTableBorderSoft = 'rgba(28, 76, 146, 0.08)';
